import React from "react";

const CasesIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 0H0V19H19V0Z" fill="#9013FE" />
      <path d="M4.75 4.75H14.25L9.5 14.25L4.75 4.75Z" fill="white" />
    </svg>
  );
};

export default CasesIcon;
